import styles from './CommonOverlayGradient.module.css'
import { Container } from '@mui/material'

const CommonOverlayGradient = () => {
    return (
        <Container className={styles.overlayGradient}/>
    )
}

export default CommonOverlayGradient